<script setup lang="ts">
import { ref } from 'vue';
import { useDialogPluginComponent } from 'quasar';

defineEmits([...useDialogPluginComponent.emits]);

const { dialogRef: uploadFileDialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent();

const localValue = ref<File[]>([]);

const clearFilesStore = () => {
  localValue.value = [];
};
</script>

<template>
  <q-dialog
    ref="uploadFileDialogRef"
    @hide="onDialogHide"
  >
    <q-card class="dialog-upload-file">
      <q-card-section class="q-px-lg q-pt-lg">
        <div class="row items-center justify-between">
          <div class="text-h6">
            Upload files
          </div>
          <q-btn
            flat
            round
            dense
            size="md"
            color="primary"
            icon="close"
            @click="onDialogHide"
          />
        </div>
      </q-card-section>
      <q-card-section class="q-px-lg">
        <q-file
          v-model="localValue"
          outlined
          multiple
          clearable
          use-chips
          counter
          color="secondary"
          label="Pick files"
          @clear="clearFilesStore"
        >
          <template #prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </q-card-section>
      <q-card-actions
        align="right"
        class="q-pa-lg"
      >
        <q-btn
          v-close-popup
          flat
          color="primary"
          label="Cancel"
          no-caps
        />
        <q-btn
          flat
          no-caps
          color="secondary"
          label="Upload"
          :disable="!localValue?.length"
          @click="onDialogOK({ localValue })"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.dialog-upload-file {
  min-width: 450px;
}
</style>
